import React from "react";

import { DebitListForCreditCard } from "@icoach/batchPayment/component";
import { useBatchPaymentContext } from "@icoach/batchPayment/component/BatchPaymentContext";

const RentCabinetBatchPaymentOverdueDebitList = ({ batchPaymentLists, ...rest }) => {
	const { creditUnpaidItems } = batchPaymentLists || {};

	const { searchParams, dialogRef, getBatchPayments } = useBatchPaymentContext();

	return <DebitListForCreditCard list={creditUnpaidItems} dialogRef={dialogRef} refresh={() => getBatchPayments(searchParams)} {...rest} />;
};

export default RentCabinetBatchPaymentOverdueDebitList;
